
import * as defaultImport from "tinycolor2";
export * from "tinycolor2";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
